import React from 'react';
import { isNil } from 'lodash';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenReviewDetail from '../../../../../components/link/OpenReviewDetail';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import Anchor from '../../../../../components/link/Anchor';
import { asyncSimpleModal } from '../../../../../lib/common';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { Columns } from '../../../../../types/common/table';
import { ReviewItemV2 } from '../../../../../types/review/list';
import { WidgetReviewFilterOption } from '../../../../../types/widget';

export const reviewReactTableColumns: Columns<ReviewItemV2, WidgetReviewFilterOption> = (data) => {
  const sortable = !!Object.keys(data).length;
  const { filterOption, onFilter } = data;

  return [
    {
      id: 'url',
      Header: '이미지',
      accessor: 'url',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} width={'60px'} height={'60px'} />,
    },
    {
      id: 'rate',
      Header: '별점',
      accessor: 'rate',
      width: 100,
      sortable,
      minWidth: 120,
    },
    {
      id: 'id',
      Header: '상품 후기 ID',
      accessor: 'id',
      filterable: !!filterOption,
      Cell: (row) => <OpenReviewDetail text={row.value} reviewId={row.value} />,
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          onFilter={(id: string): void => onFilter({ id: isNil(id) ? id : Number(id) })}
        />
      ),
    },
    {
      id: 'content',
      Header: '상품 후기 내용',
      accessor: 'content',
      filterable: !!filterOption,
      Cell: (row) => (
        <Anchor
          text="내용 보기"
          isUnderLine
          color="primary"
          onClick={async () =>
            await asyncSimpleModal({
              type: 'info',
              title: '상품 후기 내용',
              message: row.value,
            })
          }
        />
      ),
      Filter: () => (
        <TableFilterInput option={filterOption.content} onFilter={(content: string) => onFilter({ content })} />
      ),
    },
    {
      id: 'brandId',
      Header: '브랜드 ID',
      accessor: 'brandId',
      filterable: !!filterOption,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.brandId}
          onFilter={(brandId: string): void => onFilter({ brandId: isNil(brandId) ? brandId : Number(brandId) })}
        />
      ),
    },
    {
      id: 'brandName',
      Header: '브랜드명',
      accessor: 'brandName',
      filterable: !!filterOption,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.brandId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.brandName} onFilter={(brandName: string) => onFilter({ brandName })} />
      ),
    },
    {
      id: 'productId',
      Header: '상품 ID',
      accessor: 'productId',
      filterable: !!filterOption,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.productId}
          onFilter={(productId: string): void =>
            onFilter({ productId: isNil(productId) ? productId : Number(productId) })
          }
        />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      filterable: !!filterOption,
      minWidth: 200,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput
          option={filterOption.productName}
          onFilter={(productName: string) => onFilter({ productName })}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '작성 일자',
      sortable,
      minWidth: 120,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
